<div class="register-per-page">
    {{'showing' | lang}}

    <select class="table-select" (change)="changeQuantityPerPage($event)">
        <option *ngFor="let quantity of pageQuantities" [value]="quantity" [selected]="customQuantity && customQuantity === quantity">{{quantity}}</option>
    </select>

    {{'results' | lang | lowercase}} {{'from_total_of' | lang | lowercase}} {{totalRegister}}
</div>